/**
 * LOTTO-R2 추첨 알림. 전체 화면을 막지 않고 번호와 최고 당첨자만 잠깐 보여준다.
 *
 * R124(레드팀 C3, 결정 A) — **당첨 연출을 줄였다.** 확률 오락의 남의 당첨을 모든 접속자에게 축하 문구·빛 효과·9초 카드로
 * 띄우던 것을, 같은 자리의 작은 결과 카드(4~5초, 빛 효과 없음)로. 효과음은 main.js 에서 뺐다. 결과는 정보로만 알린다.
 */
import { $, esc } from '../core/state.js';
import { lotteryBallRow, lotteryRuleNote } from './panels/lottery.js';

let timer = 0;
const num = (n) => Number(n || 0).toLocaleString();

export function hideLotteryFanfare() {
  clearTimeout(timer);
  const el = $('#lottery-fanfare');
  if (el) el.classList.remove('on');
}

export function showLotteryFanfare(draw, replay = false) {
  const el = $('#lottery-fanfare');
  if (!el || !draw) return;
  clearTimeout(timer);
  const visibleFirst = (draw.firstWinners || []).filter(w => !w.privateOperator);
  const first = visibleFirst.length > 0;
  const top = (draw.topWinners || []).find(w => !w.privateOperator);
  const winners = first
    ? visibleFirst.slice(0, 3).map((w) =>
      `<b>${esc(w.name)}</b> ${num(w.bestTierGames)}게임 · ${num(w.amount)} 은화`).join('<br>')
    : top ? `최고 ${num(top.bestTier)}등 · <b>${esc(top.name)}</b> · ${num(top.amount)} 은화`
      : `${num(draw.carryAfter)} 은화가 다음 회차로 이월된다.`;
  const balls = lotteryBallRow(draw.numbers, draw.bonus, '<em>+</em>');
  el.className = 'lottery-fanfare result on';
  el.innerHTML = `<button type="button" aria-label="복권 결과 닫기">×</button>
    <small>${replay ? '운영자 재방송 · ' : ''}제 ${num(draw.drawNo)} 회 복권${esc(lotteryRuleNote(draw.ruleset, draw.currentRuleset))}</small>
    <strong>${first ? '추첨 결과 · 1등 당첨' : '추첨 결과'}</strong>
    <div class="lottery-fanfare-balls">${balls}</div>
    <p>${winners}</p>`;
  el.querySelector('button').onclick = hideLotteryFanfare;
  timer = setTimeout(hideLotteryFanfare, first ? 5000 : 4000);
}

/**
 * UNI-Q41 블랙잭 잭팟·고배당 — 같은 자리·같은 CSS 를 빌린다. 두 번째 팡파레를 따로 만들면 한쪽이 낡는다.
 * `win` 은 서버 `bjFanfare` 의 { round, name, stake, paid, jackpot, natural, cards } 다.
 */
export function showBlackjackFanfare(win) {
  const el = $('#lottery-fanfare');
  if (!el || !win) return;
  clearTimeout(timer);
  const jackpot = Number(win.jackpot) > 0;
  const cards = (win.cards || []).map((c) => `<i>${num(c)}</i>`).join('');
  const jackpotLine = jackpot ? '<br>잭팟 ' + num(win.jackpot) + ' 은화 포함' : '';
  el.className = 'lottery-fanfare result on';
  el.innerHTML = `<button type="button" aria-label="블랙잭 결과 닫기">×</button>
    <small>제 ${num(win.round)}회차 블랙잭</small>
    <strong>${jackpot ? '블랙잭 결과 · 잭팟' : '블랙잭 결과 · 고배당'}</strong>
    <div class="lottery-fanfare-balls">${cards}</div>
    <p><b>${esc(win.name)}</b> ${win.natural ? '자연 블랙잭 · ' : ''}판돈 ${num(win.stake)} → <b>${num(win.paid)} 은화</b>${jackpotLine}</p>`;
  el.querySelector('button').onclick = hideLotteryFanfare;
  timer = setTimeout(hideLotteryFanfare, jackpot ? 5000 : 4000);
}
